<nav style="--bs-breadcrumb-divider: '';" aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item "><a href="#" class="breadItem muted-color-3"> {{ 'BREADCRUMB.LABEL1' | translate }} </a></li>
    <li class="breadcrumb-item"><a href="#" class="breadItem muted-color-3"> {{ 'BREADCRUMB.LABEL2' | translate }} </a></li>
    <li class="breadcrumb-item"><a href="https://miseguro.liverpool.com.mx/mis-polizas" class="breadItem muted-color-3"> {{ 'BREADCRUMB.LABEL3' | translate }} </a></li>
    <li class="breadcrumb-item " aria-current="page" class="primary-color" style="padding-left:0.5rem; cursor: default;"> {{ 'BREADCRUMB.LABEL4' | translate }} </li>
  </ol>
</nav>